import { useCallback, useEffect, useState } from "react";
import { Container, Row } from "reactstrap";
import { LeftContactAside } from "./LeftContactAside";
import { RightContactAside } from "./RightContactAside";
import { useAppDispatch } from "../../../ReduxToolkit/Hooks";
import { Breadcrumbs } from "../../../AbstractElements";
import { Apps, ContactsTitle } from "../../../Constants/Constants";
import { fetchContacts } from "../../../ReduxToolkit/Reducers/ContactReducer";

const ContactsContainer = () => {
  const dispatch = useAppDispatch();
  const [activeTab, setActiveTab] = useState(1);
  const changeTab = useCallback((tab: number) => {
    setActiveTab(tab);
  }, []);
  useEffect(() => {
    dispatch(fetchContacts());
  }, [dispatch]);
  return (
    <>
      <Breadcrumbs mainTitle={ContactsTitle} parent={Apps} />
      <Container fluid>
        <div className="email-wrap bookmark-wrap">
          <Row>
            <LeftContactAside activeTab={activeTab} setActiveTab={setActiveTab} changeTab={changeTab} />
            <RightContactAside activeTab={activeTab} />
          </Row>
        </div>
      </Container>
    </>
  );
};
export default ContactsContainer;
